import * as axios from 'axios'
import store from '@/store/index';
import saveAs from "file-saver";

//let url = "http://localhost:8080"
let url = ""


let updatePassword = ( oldPassword, newPassword ) => {    
  const formData = new FormData()
  formData.append("oldPassword", oldPassword)
  formData.append("newPassword", newPassword)
  return communicateServerPost("api/account/changepass", formData)  
}

let sendNotice = ( notice ) => {    
  return communicateServerPost("api/notice/regist", notice) 
}

let logout =() =>{
  return communicateServerPost("logout")
}

let fetchLatestNotice = ( ) => {    
  return communicateServerGet("api/notice/latest")  
}


let sendSendMailStatus = ( id, status ) => {    
  const formData = new FormData()
  formData.append("id", id)
  formData.append("status", status)
  return communicateServerPost("api/sendmail/updateStatus", formData)  
}

let sendMail = ( title, message ) => {    
  const formData = new FormData()
  formData.append("title", title)
  formData.append("message", message)
  return communicateServerPost("api/sendmail/sendmail", formData)  
}

let fetchSendMailHistoryById = ( id ) => {  
  const formData = new FormData()
  formData.append("id", id)  
  return communicateServerPost("api/sendmail/byId", formData)  
}

let fetchSendMailHistory = () => {    
  return communicateServerGet("api/sendmail/list")  
}

let removeCatalogById = ( id ) => {    
  const formData = new FormData()
  formData.append("id", id)
  return communicateServerPost("api/catalog/deleteById", formData)  
}

let communicateServerPost = ( apiUrl, formData ) =>{
  var authToken = store.getters.getAuthToken
  
  return new Promise((resolve, reject) => {
      axios
        .post(url + '/' + apiUrl, formData
        ,{
            headers: {
                "X-AUTH-TOKEN" : authToken
            }
        } 
        )
        .then(response => {
           console.log( response )
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch((e) => {
      throw e
    })
}


function communicateServerGet( apiUrl ){
  var authToken = store.getters.getAuthToken
  
  return new Promise((resolve, reject) => {
      axios
        .get(url + '/' + apiUrl
        ,{
            headers: {
                "X-AUTH-TOKEN" : authToken
            }
        } 
        )
        .then(response => {
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch((e) => {
      throw e
    })
}


let sendCatalogIsRelease = ( id, isRelease ) => {
  return new Promise((resolve, reject) => {
      var authToken = store.getters.getAuthToken
      var formData = new FormData()
      formData.append("id", id)
      formData.append("isRelease", isRelease)
      
      axios
        .post(url + '/api/catalog/updateRelease', formData,{
            headers: {
                "X-AUTH-TOKEN" : authToken
            }}
        )
        .then(response => {           
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch((e) => {
      console.log(e)
      throw e
    })
    
}



let receiveAccountListFile = ( progressCallback ) =>{
	var authToken = store.getters.getAuthToken
    return new Promise((resolve, reject) => {
      
      axios
        .get(url + '/api/account/receivefile', {
            onDownloadProgress: progressCallback,
            headers: {
                "X-AUTH-TOKEN" : authToken
            },
            responseType: "blob",
        } )
        .then(response => {
            console.log("down")
            let mineType = response.headers["content-type"];
            console.log( response.headers["content-disposition"] )
            const name = getFileName(  response.headers["content-disposition"] ) 
            const blob = new Blob([response.data], { type: mineType });
            saveAs(blob, name);
            console.log("end")
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch((e) => {
      throw e
    })
}


let receiveCatalogFile = ( id, waterMark, progressCallback ) =>{
	var authToken = store.getters.getAuthToken
    return new Promise((resolve, reject) => {
      
     const formData = new FormData()
     formData.append('id', id)
     formData.append('waterMark', waterMark)
      
      axios
        .post(url + '/api/catalog/receivefile', formData, {
            onDownloadProgress: progressCallback,
            headers: {
                "X-AUTH-TOKEN" : authToken
            },
            responseType: "blob",
        } )
        .then(response => {
         console.log("down")
            let mineType = response.headers["content-type"];
            console.log( response.headers["content-disposition"] )
            const name = getFileName(  response.headers["content-disposition"] ) 
            const blob = new Blob([response.data], { type: mineType });
            saveAs(blob, name);
           
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch(() => {
      throw 'サーバアクセスエラー'
    })
}


function getFileName(contentDisposition){
    console.log( contentDisposition )
    let fileName = contentDisposition.substring(21,
                                                contentDisposition.length
                                                );
    //デコードするとスペースが"+"になるのでスペースへ置換します
    fileName = decodeURI(fileName).replace(/\+/g, " ");

    return fileName;
}

let loginByLoginForm = (loginForm) => {
  return new Promise((resolve, reject) => {
      axios
        .post( url  + '/api/login', loginForm )
        .then(response => {
           console.log( store.state.isLogin )
           store.commit("setAuthToken", response.headers['x-auth-token'])
           
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch((e) => {
      console.log(e)
      throw e
    })
    
}

let sendAccount = (account) => {
    
  return new Promise((resolve, reject) => {
      var authToken = store.getters.getAuthToken
      axios
        .post(url + '/api/account/regist', account,{
            headers: {
                "X-AUTH-TOKEN" : authToken
            }
        } )
        .then(response => {
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch(() => {
      throw 'サーバアクセスエラー'
    })
    
}


let sendAccountCsv = (file, uploadProgressCallback) => {
  console.log("sendAccountCsv")
  var authToken = store.getters.getAuthToken
  return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('file', file)
 
      axios
        .post(url + '/api/account/import', formData, { 
            onUploadProgress: uploadProgressCallback,
            headers: {
                "X-AUTH-TOKEN" : authToken
            }} )
        .then(response => {
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch(() => {
      throw 'サーバアクセスエラー'
    })
}

//アカウント取得
let fetchAccount = ( ) => {
  console.log( store.getters.getAuthToken )
  var authToken = store.getters.getAuthToken
  return new Promise((resolve, reject) => {
      axios
        .get(url + '/api/account/list'
        ,{
            headers: {
                "X-AUTH-TOKEN" : authToken
            }
        } 
        )
        .then(response => {
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch(() => {
      throw 'サーバアクセスエラー'
    })
}

//アカウントをID指定で取得
let fetchAccountById = (id) => { 
  const formData = new FormData()
  formData.append("id", id)
  return communicateServerPost("api/account/byId", formData) 
}

let removeAccountById = ( id ) => {
  var authToken = store.getters.getAuthToken    
  const formData = new FormData()
  formData.append("id", id)
  
  return new Promise((resolve, reject) => {
      axios
        .post(url + '/api/account/deleteById', formData
        ,{
            headers: {
                "X-AUTH-TOKEN" : authToken
            }
        } 
        )
        .then(response => {
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch(() => {
      throw 'サーバアクセスエラー'
    })
}


let fetchAccountByUserId = (userId) => {
  var authToken = store.getters.getAuthToken    
  const formData = new FormData()
  formData.append("userid", userId)
  
  return new Promise((resolve, reject) => {
      axios
        .post(url + '/api/account/byUserId', formData
        ,{
            headers: {
                "X-AUTH-TOKEN" : authToken
            }
        } 
        )
        .then(response => {
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch(() => {
      throw 'サーバアクセスエラー'
    })
}


let fetchCatalog = ( ) => {
  console.log( "fetchCatalog" )
  console.log( store.getters.getAuthToken )
  var authToken = store.getters.getAuthToken
  return new Promise((resolve, reject) => {
      axios
        .get(url + '/api/catalog/list'
        ,{
            headers: {
                "X-AUTH-TOKEN" : authToken
            }
        } 
        )
        .then(response => {
           resolve(response.data)
         }).catch(error => {
             console.log( error )
            reject(error)
         })
    })
}

let fetchCatalogById = (id) => {
  console.log( store.getters.getAuthToken )
  var authToken = store.getters.getAuthToken
  const formData = new FormData()
  formData.append('id', id)
  return new Promise((resolve, reject) => {
      axios
        .post(url + '/api/catalog/byId',formData
        ,{
            headers: {
                "X-AUTH-TOKEN" : authToken
            }
        }
        )
        .then(response => {
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch((e) => {
      throw e
    })
}

let sendCatalog = (file, catalog, uploadProgressCallback) => {
  console.log(catalog)
  
  var authToken = store.getters.getAuthToken
 
  return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('catalog', new Blob([JSON.stringify(catalog)], {type : 'application/json'}))

      axios
        .post(url + '/api/catalog/regist', formData, 
        { 
            onUploadProgress: uploadProgressCallback, 
            headers: {
                "X-AUTH-TOKEN" : authToken
            }
        
        } )
        .then(response => {
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch((e) => {
      throw e
    })
}

//商品全権取得
let fetchGoods = ( ) => {
  
  return new Promise((resolve, reject) => {
      axios
        .get(url + '/api/goods/list')
        .then(response => {
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch(() => {
      throw 'サーバアクセスエラー'
    })
}

//商品をID指定で取得
let fetchGoodsById = (id) => {
    

  return new Promise((resolve, reject) => {
      axios
        .get(url + '/api/goods/byId?id=' + id)
        .then(response => {
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch(() => {
      throw 'サーバアクセスエラー'
    })


}

//商品登録、更新
let sendGoods = (goods) => {
    
  return new Promise((resolve, reject) => {
      axios
        .post(url + '/api/goods/regist', goods )
        .then(response => {
           resolve(response.data)
         }).catch(error => {
            reject(error)
         })
    }).catch(() => {
      throw 'サーバアクセスエラー'
    })
    
}

export{ 
  fetchGoods, 
  fetchGoodsById, 
  sendGoods, 
  fetchCatalog, 
  fetchCatalogById, 
  sendCatalog, 
  sendAccountCsv,
  fetchAccount, 
  fetchAccountById, 
  sendAccount,
  loginByLoginForm,
  receiveCatalogFile,
  receiveAccountListFile,
  fetchAccountByUserId,
  removeAccountById,
  sendCatalogIsRelease,
  removeCatalogById,
  fetchSendMailHistory,
  sendMail,
  fetchSendMailHistoryById,
  sendSendMailStatus,
  sendNotice,
  fetchLatestNotice,
  logout,
  updatePassword
}
